import { useEffect } from "react";

/**
 * Sets the favicon dynamically.
 * Pass a custom URL to override the default platform favicon (e.g. clinic logo).
 * Pass skip=true to leave the current favicon untouched (e.g. when another
 * page-level call to this same hook is already responsible for it).
 */
export const useDynamicFavicon = (customFaviconUrl?: string | null, skip = false) => {
  useEffect(() => {
    if (skip) return;

    const faviconUrl = customFaviconUrl || "/favicon.png";

    // Find existing favicon link elements
    const existingFavicons = document.querySelectorAll("link[rel*='icon']");
    
    // Remove existing favicons
    existingFavicons.forEach((favicon) => favicon.remove());

    // Create new favicon link
    const link = document.createElement("link");
    link.rel = "icon";
    link.type = customFaviconUrl ? "image/png" : "image/png";
    link.href = faviconUrl;
    
    // Also create apple-touch-icon for iOS
    const appleLink = document.createElement("link");
    appleLink.rel = "apple-touch-icon";
    appleLink.href = faviconUrl;

    // Append to head
    document.head.appendChild(link);
    document.head.appendChild(appleLink);

    return () => {
      // Cleanup on unmount
      link.remove();
      appleLink.remove();
    };
  }, [customFaviconUrl, skip]);
};
